<template>
  <div v-if="open" class="fixed inset-0 z-40">
    <!-- OVERLAY -->
    <div class="fixed inset-0 bg-gray-900 opacity-70 backdrop-blur-3xl"></div>
    <!-- FILTER -->
    <div class="fixed top-0 bottom-0 right-0 bg-white max-w-xl w-9/12 md:w-1/2 p-5">
      <div class="flex justify-between items-center mb-5">
        <h2 class="font-semibold text-[22px]">
          Referral Analytics - <span :class="[referLevel.color, 'text-white text-sm px-4 py-1.5 rounded-xl']">{{ referLevel.label }} Referrer</span>
        </h2>
        <TamButton @click="closeModal" color="white" class="bg-white hover:bg-white" :icon="CloseOutline" />
      </div>

      <div class="overflow-y-auto h-[85vh] custom-scroll">
        <div class="px-2">
          <div>
            <div class="flex justify-between border-b border-gray-300 py-3 px-3" v-for="(item, idx) in summaryFormatted" :key="idx">
              <div class="capitalize text-[14px]">{{ item.label }}</div>
              <p class="font-semibold">{{ item.value }} ({{ calcPercent(item.value, summary?.all) }}%)</p>
            </div>
          </div>

          <div class="pt-2 flex space-x-6 items-center mb-3 mt-8">
            <button
              type="button"
              @click.prevent="closeModal"
              class="bg-white text-[#FE207E] font-medium px-8 py-3 rounded-lg border border-brand-black"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { CloseOutline } from '../../icons';
import TamButton from '@/components/TamButton.vue';
import { calcPercent } from '@/utils/helper';
import { ref, onMounted, computed } from 'vue';
import { useStore } from 'vuex';

const props = defineProps({
  open: { type: Boolean },
  summary: {
    type: Object,
  },
  referLevel: { type: Object },
});

const emit = defineEmits(['onClose', 'update', 'onApply']);

const closeModal = () => {
  emit('onClose');
};

const summaryFormatted = computed(() => {
  return Object.keys(props.summary).map((item) => ({ label: item.split('_').join(' '), value: props.summary[item] }));
});
</script>
